/**
 * Scroll Animation Mixin
 * Intersection Observer based scroll animations for Vue 2
 */

export const scrollAnimationMixin = {
  data() {
    return {
      observer: null,
      animatedElements: new Set(),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initScrollAnimations();
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    getAnimatedElements() {
      const root = this.$el && this.$el.querySelectorAll ? this.$el : document;

      return root.querySelectorAll("[data-animate]");
    },
    showAnimatedElements(elements) {
      elements.forEach((element) => {
        element.classList.add("animate-in");
        this.animatedElements.add(element);
      });
    },
    refreshScrollAnimations() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.animatedElements = new Set();
      this.initScrollAnimations();
    },
    initScrollAnimations() {
      const elements = this.getAnimatedElements();
      if (elements.length === 0) {
        return;
      }

      // If observers are unavailable, show content instead of leaving it hidden.
      if (typeof IntersectionObserver === "undefined") {
        console.warn(
          "IntersectionObserver not supported, showing animated elements"
        );
        this.showAnimatedElements(elements);
        return;
      }

      const options = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            // Add animation class
            element.classList.add("animate-in");
            // Unobserve after animation to improve performance
            this.observer.unobserve(element);
            this.animatedElements.add(element);
          }
        });
      }, options);

      // Observe all animated elements
      elements.forEach((el) => {
        if (!this.animatedElements.has(el)) {
          this.observer.observe(el);
        }
      });
    },
  },
};
